'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _rawStatusToType, _class, _temp;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _helpers = require('helpers');

var _PaymentStatus = require('helpers/Order/PaymentStatus');

var _PaymentStatus2 = _interopRequireDefault(_PaymentStatus);

var _PaymentStatusConstants = require('helpers/Order/PaymentStatusConstants');

var PaymentStatusConstants = _interopRequireWildcard(_PaymentStatusConstants);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    PaymentStatusLabel: {
        displayName: 'PaymentStatusLabel'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/PaymentStatusLabel/PaymentStatusLabel.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var rawStatusToType = (_rawStatusToType = {}, (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_MONEY_TRANSFER, 'info'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_RETURN, 'info'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_PARTIALLY_RETURN, 'info'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_PAY, 'success'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_NOT_PAY, 'info'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_OUTDATED, 'warning'), (0, _defineProperty3.default)(_rawStatusToType, PaymentStatusConstants.PAYMENT_STATUS_CANCEL, 'danger'), _rawStatusToType);

var PaymentStatusLabel = _wrapComponent('PaymentStatusLabel')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(PaymentStatusLabel, _Component);

    function PaymentStatusLabel(props) {
        (0, _classCallCheck3.default)(this, PaymentStatusLabel);

        var _this = (0, _possibleConstructorReturn3.default)(this, (PaymentStatusLabel.__proto__ || (0, _getPrototypeOf2.default)(PaymentStatusLabel)).call(this, props));

        _this.paymentStatusHelper = null;

        _this.paymentStatusHelper = new _PaymentStatus2.default(props.rawStatus);
        return _this;
    }

    (0, _createClass3.default)(PaymentStatusLabel, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nProp) {
            if (this.props.rawStatus !== nProp.rawStatus) {
                this.paymentStatusHelper = new _PaymentStatus2.default(nProp.rawStatus);
            }
        }
    }, {
        key: 'getLabelTypeForRawStatus',
        value: function getLabelTypeForRawStatus() {
            return rawStatusToType[this.props.rawStatus];
        }
    }, {
        key: 'render',
        value: function render() {
            var View = _helpers.ThemeHelper.getViewForComponent('PaymentStatusLabel');

            return _react3.default.createElement(View, {
                type: this.getLabelTypeForRawStatus(),
                labelText: this.paymentStatusHelper.toString()
            });
        }
    }]);
    return PaymentStatusLabel;
}(_react2.Component), _class.propTypes = {
    rawStatus: _propTypes2.default.number.isRequired
}, _temp));

exports.default = PaymentStatusLabel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentStatusLabel/PaymentStatusLabel.jsx
// module id = 754
// module chunks = 0